import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React, { FC, useState } from "react";
import GoogleCustomersMapV2 from "../extras/GoogleCustomersMapV2";
import SummaryRow from "./StaffHomepage/SummaryRow";
import WelcomeRow from "./StaffHomepage/WelcomeRow";
import NeedsAttentionCol from "./StaffHomepage/NeedsAttentionCol";
import RecentActivityCol from "./StaffHomepage/RecentActivityCol";
import ActionsRow from "./StaffHomepage/ActionsRow";

interface IProps {};

const AlphaInsightsStaffHome:FC<IProps> = (props) => {
    const [refreshDate, setRefreshDate] = useState(new Date())
    return <IonGrid >
        <WelcomeRow date={refreshDate}/>
        <SummaryRow setDate={setRefreshDate}/>
        <IonRow>
            <IonCol size="9">
                <IonRow className=" ion-justify-content-center">
                    <GoogleCustomersMapV2/>
                </IonRow>
                <ActionsRow/>
            </IonCol>
            <IonCol >
                <IonRow  className="h-100" style={{flexDirection:'column', padding:'0 1rem'}}>
                    <NeedsAttentionCol/>
                    <RecentActivityCol/>
                </IonRow>
            </IonCol>
        </IonRow>
    </IonGrid>
};

export default AlphaInsightsStaffHome;